import {firstLetterToUpperCase} from "../workTablePatients/PatientsList";
import {DoctorTitleCase, getDoctorTitle} from "../../utils/common";
import {UserRole} from "../../helpers/UserRole";

export function getActionLogUserRoleDisplayName(role: UserRole): String {
    switch (role) {
        case UserRole.ADMIN:
            return "Администратор";
        case UserRole.DOCTOR:
            return firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im));
        case UserRole.OBSERVER:
            return "Наблюдатель";
    }
}